import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8","key":"svg-0"}],["path",{"d":"M18 4v17","key":"svg-1"}],["path",{"d":"M15 18l3 3l3 -3","key":"svg-2"}]]

const IconArrowAutofitDown = createReactComponent('outline', 'arrow-autofit-down', 'ArrowAutofitDown', __iconNode);

export default IconArrowAutofitDown;